export enum CertificationStatus {
    PreInstallCertified = 1,
    InstallChangeCertified = 2,
    AsBuiltCertified = 3,
    CertifiedDesignOverride = 4,
}